import { render, staticRenderFns } from "./_subCategory.vue?vue&type=template&id=782e6374&scoped=true&"
import script from "./_subCategory.vue?vue&type=script&lang=js&"
export * from "./_subCategory.vue?vue&type=script&lang=js&"
import style0 from "./_subCategory.vue?vue&type=style&index=0&id=782e6374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782e6374",
  null
  
)

export default component.exports